import { render, staticRenderFns } from "./PlayersListItem.vue?vue&type=template&id=20b3821c"
import script from "./PlayersListItem.vue?vue&type=script&lang=js"
export * from "./PlayersListItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports